<template>
	<div>
		<ContainedSection
			:has-padding="false"
			:has-background="true"
			background-color="bg-white"
		>
			<TwoColumns
				:has-padding-first-column="true"
				first-column-class="order-last lg:order-none"
			>
				<template #first>
					<BreadcrumbNavigation :crumbs="crumbs" />

					<h1 class="mb-8 mt-8">
						Flexible, all-inclusive car subscription
					</h1>
					<div class="space-y-5 text-lg text-gray-575">
						<p>
							Forget financing, balloon payments, interest,
							depreciation, insurance, rego and all the variable
							maintenance and servicing costs.
						</p>
						<p>
							For a fixed weekly payment, we take care of all that
							for you^.
						</p>
					</div>
					<div class="mt-8 space-y-2">
						<div
							v-for="(list, key) in heroList"
							:key="key"
							class="flex flex-col"
						>
							<div>
								<CarbarButton
									:is-full-width="false"
									:is-outline="key !== 0"
									:is-mixed="true"
									border-color="text-orange-400"
									class="text-left"
									@click="scrollTo(`#${list.scrollTo}`)"
								>
									{{ list.label }}
								</CarbarButton>
							</div>
						</div>
					</div>
					<div class="mt-8">
						<TermsAndConditions :is-full-width="false">
							^ Excludes tolls, fuel and infringements.
							<CarbarLink
								href="/terms-and-conditions/car-subscription"
								target="_blank"
								text="Terms and conditions"
								class="text-xsm"
							/>
							apply.
						</TermsAndConditions>
					</div>
				</template>
				<template #second>
					<div class="h-full">
						<div class="flex h-full items-center">
							<CarbarImage
								image="img/car-subscription/hero-subs.webp"
								class="mt-4 lg:mt-0"
								alt-text="Car subscriptions"
							/>
						</div>
					</div>
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection id="what-is-car-subscription" :has-background="true">
			<WhatIsCarSubscription />
		</ContainedSection>

		<ContainedSection
			id="what-is-included-in-a-car-subscription"
			:has-padding="false"
		>
			<TwoColumns
				columns-order="flex-col xl:flex-row"
				first-column-width="w-full xl:w-1/3"
				second-column-width="w-full xl:w-2/3"
				first-column-class="bg-white contained-section"
				second-column-class="bg-white contained-section"
				column-gap="gap-6"
			>
				<template #first>
					<SubscriptionIncludes />
				</template>
				<template #second>
					<BenefitsOfCarSubscription />
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection id="how-does-a-car-subscription-works">
			<HowCarSubscriptionWork />
		</ContainedSection>

		<ContainedSection
			:has-padding="false"
			:has-background="true"
			background-color="bg-white"
		>
			<PriceMatchGuarantee />
		</ContainedSection>

		<ContainedSection :has-padding="false" :has-background="true">
			<WhySellYourCarToUs />
		</ContainedSection>

		<ContainedSection :has-padding="false" :has-background="true">
			<SellingOrUpgradingCar heading="A simple way to sell your car" />
		</ContainedSection>

		<ContainedSection
			:has-background="true"
			:has-padding="false"
			background-color="bg-white"
			custom-class="text-center contained-section"
		>
			<Elfsight />
		</ContainedSection>

		<ContainedSection v-if="false" :has-background="true">
			<ImageAndContent content-column-class="flex items-center">
				<template #content>
					<div>
						<h2>Subscribe now, buy later</h2>
						<div class="space-y-5 text-lg text-gray-575">
							<p>
								Pay a little extra a week and use the credit to
								buy the car when you finish.
							</p>
							<p>
								Your flexibility remains. You can use your
								credit to buy your subscription car at the
								agreed price, or use it as a deposit on a new
								car. The choice is yours.
							</p>
						</div>
						<div class="mt-8">
							<CarbarLink
								:underline="false"
								href="/car-subscription/subscribe-now-buy-later"
							>
								<CarbarButton :is-full-width="false">
									Learn more about Subscribe now, buy later
								</CarbarButton>
							</CarbarLink>
						</div>
					</div>
				</template>
				<template #image>
					<div class="w-full">
						<CarbarImage
							image="img/car-subscription/img-snbl.webp"
							alt-text="Subscribe Now, Buy Later"
						/>
					</div>
				</template>
			</ImageAndContent>
		</ContainedSection>

		<ContainedSection :has-padding="false" :has-background="true">
			<CheckIfEligible />
		</ContainedSection>

		<ContainedSection
			id="car-subscription-for-business"
			:has-padding="false"
			:has-background="true"
			background-color="bg-white"
		>
			<TwoColumns
				:has-padding-first-column="true"
				first-column-class="order-last lg:order-none"
			>
				<template #first>
					<div>
						<h2>
							A flexible, tax effective way to salary package your
							car!
						</h2>
						<p class="text-lg text-gray-575">
							Enjoy all the convenience and potential tax savings
							that come with traditional salary packaging with the
							simplicity and flexibility of a car subscription.
						</p>
					</div>
					<div class="mt-8 w-full lg:w-auto">
						<CarbarLink href="/business" :underline="false">
							<CarbarButton :is-full-width="false">
								Explore car subscriptions for business
							</CarbarButton>
						</CarbarLink>
					</div>
				</template>

				<template #second>
					<div class="h-full">
						<div class="flex h-full items-center">
							<CarbarImage
								image="img/car-subscription/img-salary-package.webp"
								alt-text="Salary packaging"
							/>
						</div>
					</div>
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection
			id="join-for-free"
			:has-padding="false"
			:has-background="true"
		>
			<StartSubscriptionJourney
				heading="Start your subscription journey here"
				image="img/car-subscription/img-start_a_journey.webp"
			/>
		</ContainedSection>

		<ContainedSection>
			<FaqsCarSubscription />
		</ContainedSection>

		<ContainedSection>
			<h2 class="lg:text-2xl">Search by popular makes and models</h2>
			<SectionsListPopularBrandsAndModels class="mt-5" />
		</ContainedSection>
	</div>
</template>

<script setup>
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import BenefitsOfCarSubscription from '@/components/car-subscriptions/BenefitsOfCarSubscription.vue'
import CheckIfEligible from '@/components/car-subscriptions/CheckIfEligible.vue'
import HowCarSubscriptionWork from '@/components/car-subscriptions/HowCarSubscriptionWork.vue'
import WhatIsCarSubscription from '@/components/car-subscriptions/WhatIsCarSubscription.vue'
import SellingOrUpgradingCar from '@/components/home/SellingOrUpgradingCar.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import ImageAndContent from '@/components/sections/ImageAndContent.vue'
import StartSubscriptionJourney from '@/components/sections/StartSubscriptionJourney.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import FaqsCarSubscription from '@/components/car-subscriptions/FaqsCarSubscription.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import WhySellYourCarToUs from '@/components/sell-my-car/WhySellYourCarToUs.vue'
import SubscriptionIncludes from '@/components/car-subscriptions/SubscriptionIncludes.vue'
import PriceMatchGuarantee from '@/components/car-subscriptions/PriceMatchGuarantee.vue'
import Elfsight from '@/components/elfsight/Elfsight.vue'

definePageMeta({
	trustMary: {
		enable: true,
	},
})

const heroList = [
	{
		label: 'What is a car subscription?',
		scrollTo: 'what-is-car-subscription',
	},
	{
		label: 'What is included in a car subscription?',
		scrollTo: 'what-is-included-in-a-car-subscription',
	},
	{
		label: 'How does a car subscription work?',
		scrollTo: 'how-does-a-car-subscription-works',
	},
	{
		label: 'Car subscription for business',
		scrollTo: 'car-subscription-for-business',
	},
]

const crumbs = [
	{
		title: 'Home',
		url: '/',
	},
	{
		title: 'Car subscription',
	},
]
</script>
